/** @jsxRuntime classic */
/** @jsx jsx */
import {jsx} from "@emotion/core";
import React, {CSSProperties} from 'react';
import {FieldDef} from "../types";
import {FormGroup, Select} from "@ice/components";
import {$t} from "../lang/LangUtil";


interface DatasetFieldSelectProps {
    label?: string;
    fields: FieldDef[];
    value?: FieldDef;
    onFieldSelect?: (fieldDef: FieldDef) => void;
    disabled?: boolean;
    style?: CSSProperties;
}


interface DatasetFieldSelectState {
    value: FieldDef;
}


export class DatasetFieldSelect extends React.Component<DatasetFieldSelectProps, DatasetFieldSelectState> {

    constructor(props: DatasetFieldSelectProps) {
        super(props);
        this.state = {
            value: this.props.value
        }
    };

    render = () => {
        const fields = this.props.fields;
        const select = <Select<FieldDef>
            clearable={false}
            searchable={true}
            getValue={(i) => fields[i]}
            getSelectionLabel={def => def.name}
            getOptionLabel={(i) => fields[i].name}
            onChange={(fieldDef: FieldDef) => {
                this.setState({value: fieldDef});
                if (this.props.onFieldSelect) {
                    this.props.onFieldSelect(fieldDef);
                }
            }}
            optionCount={fields.length}
            value={this.state.value}
            disabled={this.props.disabled}
            style={this.props.style}
        />;
        return this.props.label ?
            <FormGroup inline label={this.props.label ?? $t("field")}>{select}</FormGroup> :
            select;
    }

}
